export default "__VITE_ASSET__CKMgNy7K__"